/**
 * Abort asks before it aborts — decision D4 and the old screen's pattern
 * ("Are you sure you want to abort?" / No / Yes, `BottomControlsComponent`
 * L175-192). Before this it was ONE tap to end the game (P1-1).
 *
 * The old component also closes a dialog left open when the window shuts
 * (`useEffect` on `showAbort`, L52-56); here the whole tile unmounts, which does
 * the same thing.
 */
import React, {useCallback, useState} from 'react';

import {ConfirmDialog, Tile} from '../../../../ui';
import {AbortTileModel} from './AbortTile.model';

/** BottomControlsComponent L178, verbatim. */
export const ABORT_CONFIRM_COPY = 'Are you sure you want to abort?';

export default React.memo(function AbortTileView({
  showAbort,
  onPress,
}: AbortTileModel) {
  const [asking, setAsking] = useState(false);

  const onCancel = useCallback(() => setAsking(false), []);
  const onConfirm = useCallback(() => {
    setAsking(false);
    onPress();
  }, [onPress]);

  if (!showAbort) {
    return null;
  }
  return (
    <>
      <Tile
        icon="abort"
        label="Abort"
        tone="danger"
        onPress={() => setAsking(true)}
      />
      <ConfirmDialog
        testID="v2-confirm-abort"
        visible={asking}
        title={ABORT_CONFIRM_COPY}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </>
  );
});
